import ApplicationAdapter from './application';

/**
 * This adapter is used to get the resource for an assignment at /postings/*
 */
class AssignmentAdapter extends ApplicationAdapter {
  /**
   * @returns {string}
   */
  pathForType() {
    return 'postings';
  }
}

export default AssignmentAdapter;
